import React from "react";
import MicrophoneIcon from "../../assets/microphone.svg";
import "../../styles/components/useroverlay/MicButton.css";

export interface MicButtonProps {
  // Visual state flags
  active: boolean;
  isWindowFocused: boolean;
  visible: boolean;
  hasEverTransmitted: boolean;
  isTalkingButNotTransmitting: boolean;
  
  // Display content
  text?: string;
  micColor?: string;
  showIcon?: boolean;
  
  // Optional className for layout variations
  className?: string;
}

const MicButton: React.FC<MicButtonProps> = ({
  active,
  isWindowFocused,
  visible,
  hasEverTransmitted,
  isTalkingButNotTransmitting,
  text,
  micColor,
  showIcon = true,
  className = '',
}) => {
  // Build microphone classes
  const microphoneClasses = [
    'mic-button',
    active && 'active',
    !isWindowFocused && 'window-not-focused',
    !visible && 'mic-button-hidden',
    !hasEverTransmitted && isTalkingButNotTransmitting && 'bright-orange-appearance',
    className,
  ].filter(Boolean).join(' ');

  // Build microphone styles
  const microphoneStyles = micColor ? { backgroundColor: micColor } : undefined;

  return (
    <div
      className={microphoneClasses}
      style={microphoneStyles}
    >
      {showIcon && <img src={MicrophoneIcon} alt="mic" className="mic-icon no-loupe" />}
      {text && <span className="mic-text no-loupe">{text}</span>}
    </div>
  );
};

export default MicButton;
